module.exports = __webpack_public_path__ + "static/img/Receive3Hot.ca08faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Receive3Hot.png
// module id = IBRJ
// module chunks = 0